import * as React from 'react'
import { cn } from 'design-system/shadcn/lib/utils'
import { SearchIcon } from 'lucide-react'

const DropdownInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'>
>(({ className, type, ...props }, ref) => {
  return (
    <div className="ds-relative">
      <input
        type={type}
        className={cn(
          'ds-placeholder:text-white-900 ds-bg-white ds-flex ds-min-h-[36px] ds-w-full ds-rounded-[8px] ds-border-b-1 ds-border-white-800 ds-px-8 ds-py-4 ds-text-[14px] ds-caret-blue-600 ds-shadow-none  ',
          className,
        )}
        ref={ref}
        {...props}
      />
      <div className="ds-absolute ds-right-12 ds-top-1/2 ds--translate-y-1/2">
        <SearchIcon
          className="ds-h-[16px] ds-w-[16px] ds-text-black-500"
          strokeWidth={1.5}
        />
      </div>
    </div>
  )
})
DropdownInput.displayName = 'Input'

export { DropdownInput as Input }
